import React from "react";
import Sidebar from "../components/Sidebar";
import "../css/AdminLayout.css";

const AdminLayout = ({ children }) => {
  return (
    <div className="admin-layout">
      <Sidebar />
      <main className="admin-content">{children}</main>
    </div>
  );
};

export default AdminLayout;
